/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Floating_Choose_Space_To_CompareInputs */



/**
* | output |
* | --- |
* | "Choose a space to compare with {name}." |
*
* @param {Spaces_Floating_Choose_Space_To_CompareInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_choose_space_to_compare = /** @type {((inputs: Spaces_Floating_Choose_Space_To_CompareInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Choose_Space_To_CompareInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wählen Sie einen Space, um ihn mit ${i?.name} zu vergleichen.`)
	return /** @type {LocalizedString} */ (`Choose a space to compare with ${i?.name}.`)
});